import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Toothbrush = memo((props: IconProps) => {
    const { color = "#0E0E0E", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 17 31" fill="none" {...rest}>
            <path
                d="M15.678 11.113H8.136l.496-2.922a2.45 2.45 0 0 1 2.501-2.054l.362-2.126a.525.525 0 0 1 .611-.433l2.099.355c.14.026.263.102.345.219a.538.538 0 0 1 .09.392l-.362 2.125c.41.134.78.366 1.073.68.517.563.739 1.332.612 2.087l-.28 1.678h-.005ZM.013.923l1.343 7.312a.522.522 0 0 0 .123.256l1.948 2.215.074.41h2.704L5.918 9.56a.49.49 0 0 0-.123-.257L3.847 7.09l-.17-.903 2.091-.383a.526.526 0 0 0 .427-.618.528.528 0 0 0-.618-.427l-2.092.386-.096-.526 2.092-.383a.53.53 0 0 0 .423-.622.53.53 0 0 0-.622-.424l-2.088.386-.096-.526 2.088-.383a.526.526 0 0 0 .427-.618.526.526 0 0 0-.618-.427l-2.088.386-.096-.526L4.9 1.099A.526.526 0 0 0 5.326.48a.526.526 0 0 0-.618-.428L2.616.44a.51.51 0 0 0-.219-.346.55.55 0 0 0-.4-.085L.433.299a.527.527 0 0 0-.424.615l.004.009Zm.53 11.848 2.125 17.525c.031.267.26.468.526.468h11.15c.27 0 .496-.201.527-.468l2.125-17.525c0-.02.004-.041.004-.065a.53.53 0 0 0-.53-.53H1.07c-.02 0-.042 0-.066.004-.29.034-.5.3-.464.591h.003Z"
                fill={color}
            />
        </svg>
    )
})

export default Toothbrush
